export function firstName(value) {
    if (typeof value !== 'string' || value.includes('@')) return null;
    return value.trim().split(/\s+/)[0] || null;
}

export function surfaceLabel(context) {
    if (context === 'designer') return 'Designer';
    if (context === 'explorer') return 'Explorer';
    if (context === 'settings') return 'Console account settings';
    return 'Console';
}

export function buildGreeting(name, context) {
    const normalizedName = firstName(name);
    return `Hello${normalizedName ? ` ${normalizedName}` : ''}, I see you’re using the ${surfaceLabel(context)}. What can I help you with?`;
}

export function voiceControlLabel(isMuted) {
    return isMuted ? 'Unmute Sam voice' : 'Mute Sam voice';
}

export function microphoneControlLabel(isMuted) {
    return isMuted ? 'Unmute your microphone' : 'Mute your microphone';
}

export const AUTOPLAY_FALLBACK = 'Sam could not start speaking automatically. You can still speak or type your question.';

export function speechRecognitionSupported(browserWindow) {
    return !!(browserWindow?.SpeechRecognition || browserWindow?.webkitSpeechRecognition);
}

export function microphoneStatusText({ supported, listening, muted, error }) {
    if (muted) return 'Your microphone is muted. Unmute it above to speak with Sam, or type your question below.';
    if (error) return `${error} Mute, then unmute your microphone above to retry browser permission or microphone startup.`;
    if (listening) return 'Your microphone is listening. Speak naturally, or type your question below.';
    if (supported) return 'Microphone is not listening yet.';
    return 'Type your question below. Voice input is not available in this browser.';
}

export function microphoneErrorText(errorCode) {
    if (errorCode === 'not-allowed' || errorCode === 'service-not-allowed') {
        return 'Browser microphone permission was not granted.';
    }
    if (errorCode === 'audio-capture') return 'No microphone is available to the browser.';
    return 'The browser could not start microphone listening.';
}

export function shouldRequestMicResume({ supported, muted, speaking, loading }) {
    return supported && !muted && !speaking && !loading;
}
